import styled from "styled-components";
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

/* eslint-disable */
interface ContainerProps {
  active: boolean;
}

const Container = styled(Button)<ContainerProps>`
  &:disabled {
    cursor: default;
  }

  background-color: ${({ active, theme }) => active ? "#f00" : theme.colors.disabled } !important;
  color: #fff !important;
`;

export { Container };
